const advertising = {
    path: 'advertising',
    component: resolve => require(['@/pages/admin/ad/advertising/index.vue'], resolve),
    meta: {
        requireAuth: true
    }
}

export default advertising
